module.exports = __webpack_public_path__ + "img/icon_footer_fantasy_unselect.dcd25cfb.png";